import moment from 'moment'
import axios from "axios";

export function numberWithSpaces(value, pattern) {
    var i = 0,
      phone = value.toString();
    return pattern.replace(/#/g, _ => phone[i++]);
  }
  
export function htmlEntity(str) {
    return str.replace(/\n/g, "<br />");
}
export function convertTimeHuman(seconds) {
    var seconds = parseInt(seconds, 10)
    var hours = Math.floor(seconds / 3600)
    var minutes = Math.floor((seconds - (hours * 3600)) / 60)
    var seconds = seconds - (hours * 3600) - (minutes * 60)
    if (!!hours) {
        if (!!minutes) {
            return `${hours}h ${minutes}m ${seconds}s`
        } else {
            return `${hours}h ${seconds}s`
        }
    }
    if (!!minutes) {
        return `${minutes}m ${seconds}s`
    }
    return `${seconds}s`
}

export function showDateRoomList(unxTimestamp) {
    let yesterday = moment().add(-1,'days').unix();
    // let yesterday = moment.subtract(1, 'days').unix()
    // console.log("temp",temp)
    // console.log("yesterday",yesterday)
    // console.log("unxTimestamp",unxTimestamp)
    if (unxTimestamp < yesterday) {
        return formatFromUnixToDate(unxTimestamp)
    } else {
        return formatHourFromUnix(unxTimestamp)
        // return timeAgo(unxTimestamp)
    }
}

export function timeAgo(unxTimestamp) {
    var newDate = moment.unix(unxTimestamp).fromNow();
    return newDate
}
export async function downloadImage(url, title) {
    if (typeof (title) == 'undefined' || title == "") {
        title = "file"
    }
    var base64 = await axios
        .get(url, {
            responseType: "arraybuffer"
        })
        .then(response =>
            // Buffer.from(response.data, "binary").toString("base64")
            forceFileDownload(response, title + ".jpeg")

        );
    var img = new Image();
    img.src = "data:image/jpeg;base64, " + base64;
    return img;
}
export function forceFileDownload(response, title) {
    console.log(title)
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', title)
    document.body.appendChild(link)
    link.click()
}
export function hasPermissionForRoute(roles, route) {
    if (route.meta && route.meta.roles) {
        return roles.some(role => route.meta.roles.includes(role))
    } else {
        return true
    }
}

export function labelPackageProduct(value) {
    let label = value;
    if (value == "monthly") {
        label = "1 Bulan"
    } else if (value == "6_months") {
        label = "6 Bulan"
    } else if (value == "3months") {
        label = "3 Bulan"
    } else if (value == "annually") {
        label = "1 Tahun"
    } else if (value == "tendays") {
        label = "Free Trial"
    }
    return label
}

export function labelPackageProductEnglish(value) {
    let label = value;
    if (value == "monthly") {
        label = "1 Month"
    } else if (value == "3months") {
        label = "3 Months"
    } else if (value == "annually") {
        label = "1 Year"
    }
    return label
}

export function labelStatusMessage(value) {
    value = parseInt(value)
    let label = value;
    if (value == 0) {
        label = "ERROR"
    } else if (value == 1) {
        label = "PENDING"
    } else if (value > 1) {
        label = "SUCCESS"
    }
    return label
}
export function calculateSeconds(second) {
    var d = second;
    var r = {};                                                                // result
    var s = {                                                                  // structure
        year: 31536000,
        month: 2592000,
        week: 604800, // uncomment row to ignore
        day: 86400,   // feel free to add your own row
        hour: 3600,
        minute: 60,
        second: 1
    };

    Object.keys(s).forEach(function (key) {
        // console.log("d", d)
        r[key] = Math.floor(d / s[key]);
        d -= r[key] * s[key];
    });

    let label = ""
    let index = 0
    Object.keys(r).forEach(function (key) {
        // console.log("keyy", key)
        // r[key] = Math.floor(d / s[key]);
        // d -= r[key] * s[key];

        if (r[key] > 0) {
            label += (index == 0) ? (r[key] + key) : " " + (r[key] + key)
        }
        index++
    });
    // r.forEach(row,ind)
    // console.log("rrr", r)

    return label;
}



export function getCurrentMonth() {
    var date = new Date()

    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var monthDisp = monthIndex + 1;
    monthDisp = (monthDisp < 10) ? '0' + monthDisp : monthDisp;
    return year + "-" + monthDisp;
}
export function nFormatter(num) {
    if (num >= 1000000000) {
        return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'G';
    }
    if (num >= 1000000) {
        return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    }
    if (num >= 1000) {
        return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    }
    return num;
}

export function convertQtyFromQuoteAsset(numQuote, price) {
    let numQuoteNumber = parseFloat(numQuote)
    let priceNumber = parseFloat(price)

    if (numQuoteNumber <= 0 || priceNumber <= 0) {
        return 0;
    } else {
        return Math.ceil((nrOfDecimals(numQuoteNumber / priceNumber)))
    }
}

export function convertClearenceQtyToQuoteAsset(numQty, price) {
    let numQtyNumber = parseFloat(numQty)
    let priceNumber = parseFloat(price)

    if (numQtyNumber <= 0 || priceNumber <= 0) {
        return 0;
    } else {
        return Math.floor(nrOfDecimals(numQtyNumber * priceNumber))
    }
}

export function convertTzDatetimeToHour(utcDateTime) {
    var newDate = moment.utc(utcDateTime, "YYYY-MM-DDTHH:mm:ssZ");
    return newDate.format("HH:mm")
}
export function convertTzDatetimeToDateISO(utcDateTime) {
    var newDate = moment.utc(utcDateTime, "YYYY-MM-DDTHH:mm:ssZ");
    return newDate.format("YYYY-MM-DD")
}
export function convertTzDatetimeToUnixv2(utcDateTime) {
    var newDate = moment.utc(utcDateTime, "YYYY-MM-DDTHH:mm:ssZ");

    return newDate.unix()
}

export function convertTzDatetimeToUnix(utcDateTime) {
    var newDate = moment.utc(utcDateTime, "YYYY-MM-DD HH:mm:ss");

    return newDate.unix()
}

export function convertUTCDatetimeToUnix(utcDateTime) {
    var newDate = moment.utc(utcDateTime, "YYYY-MM-DD HH:mm:ss");

    return newDate.unix()
}


export function currentDateTimeUnix() {
    // console.log("moment", moment)
    // console.log("unxTimestamp", unxTimestamp)
    let dateLocal =
        moment().unix()

    return dateLocal;
}

export function currentDateTimeUTC() {
    // console.log("moment", moment)
    // console.log("unxTimestamp", unxTimestamp)
    let dateLocal =
        moment().utc().format()

    return dateLocal;
}


export function currentDate() {
    // console.log("moment", moment)
    // console.log("unxTimestamp", unxTimestamp)
    let dateLocal =
        moment().format(
            "dddd, Do MMMM YYYY"
        )

    return dateLocal;
}

export function formatHourFromUnix(unxTimestamp) {
    // console.log("moment", moment)
    // console.log("unxTimestamp", unxTimestamp)
    let dateLocal =
        moment.unix(unxTimestamp).format(
            "HH:mm"
        )

    return dateLocal;
}


export function formatLocalDateWithDay(unxTimestamp) {
    // console.log("moment", moment)
    // console.log("unxTimestamp", unxTimestamp)
    let dateLocal =
        moment.unix(unxTimestamp).format(
            "dddd, Do MMMM YYYY HH:mm"
        )

    return dateLocal;
}


export function formatLocalDateWithSeconds(unxTimestamp) {
    // console.log("moment", moment)
    // console.log("unxTimestamp", unxTimestamp)
    let dateLocal =
        moment.unix(unxTimestamp).format(
            "Do/MM/YYYY, HH:mm:ss"
        )

    return dateLocal;
}

export function formatLocalDate(unxTimestamp) {
    // console.log("moment", moment)
    // console.log("unxTimestamp", unxTimestamp)
    let dateLocal =
        moment.unix(unxTimestamp).format(
            "Do/MM/YYYY, HH:mm"
        )

    return dateLocal;
}


export function formatFromUnixToDate(unxTimestamp) {
    // console.log("moment", moment)
    // console.log("unxTimestamp", unxTimestamp)
    let dateLocal =
        moment.unix(unxTimestamp).format(
            "YYYY-MM-DD"
        )

    return dateLocal;
}

// export function formatLocalDate(unxTimestamp) {
//     var date = new Date(unxTimestamp * 1000);
//     var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);

//     var offset = date.getTimezoneOffset() / 60;
//     var hours = date.getHours();
//     // console.log("offset", offset)
//     // newDate.setHours(hours - offset);
//     newDate.setHours(hours);

//     return newDate;
// }
export function nrOfDecimals(number) {
    var match = ('' + number).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    if (!match) { return 0; }

    var decimals = Math.max(0,
        (match[1] ? match[1].length : 0)
        // Correct the notation.
        - (match[2] ? +match[2] : 0));

    if (decimals > 8) {
        //if decimal are more then 8
        number = parseFloat(number).toFixed(8);
    } else {
        number = parseFloat(number).toFixed(decimals);
    }
    // else no adjustment is needed
    return (number * 1);
    // var noZeroes = number.toString()
    // return noZeroes;
    // return +(Math.round(number + "e+2")  + "e-2");

}

export function formatPriceRupiah(value) {
    let val = (value / 1).toFixed(0).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}


export function formatPrice(value) {
    let val = (value / 1).toFixed(2).replace(',', '.')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

export function formatSizes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
//getWhatsappNumberFromJid
export function getWhatsappNumberFromJid(number) {
    // console.log("getWhatsappNumberFromJid:", number)
    if (number != "") {
        //check is grup
        // var splitArr = number.split("@g")
        // console.log("splitArr:", splitArr)
        // console.log("regex:", number.match('@g'))
        if (number.match('@g') != null) {
            // number = splitArr[0]
            return number
        }
        var splitArr = number.split("@")
        if (splitArr.length > 0) {
            number = splitArr[0]
            return number
        }
    }

    return number
}

//getWhatsappJid
export function getWhatsappJid(number) {
    var suffix = "@s.whatsapp.net"
    return number + suffix
}

export function formatDate(dateValue, formatType = "month_name") {
    var date = new Date(dateValue)
    var monthNames = [
        "Jan", "Feb", "Mar",
        "Apr", "May", "Jun", "Jul",
        "Aug", "Sep", "Oct",
        "Nov", "Dec"
    ];

    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();
    var outputDate = ""
    if (Number.isNaN(monthIndex) == true) {
        return "-"
    }
    switch (formatType) {
        default:
            outputDate = day + ' ' + monthNames[monthIndex] + ' ' + year;
            break;
        case "iso":
            var isoDate = new Date(year, monthIndex, day);
            outputDate = isoDate.toISOString().slice(0, 10);
            break;
        case 'datetime':
            var hours = date.getHours();
            hours = (hours < 10) ? '0' + hours : hours
            var minutes = date.getMinutes();
            var seconds = date.getSeconds();
            monthIndex = (monthIndex + 1)
            monthIndex = (monthIndex < 10) ? "0" + monthIndex : monthIndex
            day = (day < 10) ? "0" + day : day
            minutes = (minutes < 10) ? "0" + minutes : minutes
            seconds = (seconds < 10) ? "0" + seconds : seconds
            outputDate = day + '/' + monthIndex + '/' + year + " " + hours + ":" + minutes + ":" + seconds;
            break;
    }
    return outputDate;
}

const CHAT_DATE_MONTHS_ID = [
    "Januari", "Februari", "Maret", "April", "Mei", "Juni",
    "Juli", "Agustus", "September", "Oktober", "November", "Desember"
];

function padChatDatePart(value) {
    return value < 10 ? "0" + value : String(value);
}

function formatChatDateKey(date) {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
        return "";
    }
    return date.getFullYear() + "-" + padChatDatePart(date.getMonth() + 1) + "-" + padChatDatePart(date.getDate());
}

function formatChatDateKeyInTimeZone(date, timeZone) {
    if (!timeZone) {
        return formatChatDateKey(date);
    }

    try {
        const parts = new Intl.DateTimeFormat("en-CA", {
            timeZone: timeZone,
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        }).formatToParts(date);
        const values = {};
        parts.forEach(part => {
            if (part.type !== "literal") {
                values[part.type] = part.value;
            }
        });
        if (values.year && values.month && values.day) {
            return values.year + "-" + values.month + "-" + values.day;
        }
    } catch (error) {
        // Timezone tidak valid / Intl tidak tersedia: pakai waktu lokal.
    }
    return formatChatDateKey(date);
}

function parseChatDateKey(value) {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || "").trim());
    if (!match) {
        return null;
    }

    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    if (month < 1 || month > 12 || day < 1 || day > 31) {
        return null;
    }

    const date = new Date(year, month - 1, day);
    if (
        date.getFullYear() !== year ||
        date.getMonth() !== month - 1 ||
        date.getDate() !== day
    ) {
        return null;
    }
    return date;
}

function parseChatDateNumber(value) {
    if (value === null || typeof value === "undefined" || value === "") {
        return null;
    }

    const isNumeric = typeof value === "number" || /^-?\d+$/.test(String(value).trim());
    if (isNumeric) {
        let numeric = Number(value);
        if (!Number.isFinite(numeric) || numeric <= 0) {
            return null;
        }
        // API omni mengirim Unix seconds. Nilai di bawah 1e11 masih seconds;
        // nilai yang lebih besar diperlakukan sebagai milliseconds.
        if (Math.abs(numeric) < 100000000000) {
            numeric *= 1000;
        }
        const date = new Date(numeric);
        return Number.isNaN(date.getTime()) ? null : date;
    }

    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
}

function parseChatDateTimeLocal(value) {
    const match = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?/.exec(
        String(value || "").trim()
    );
    if (!match) {
        return null;
    }

    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const hour = Number(match[4] || 0);
    const minute = Number(match[5] || 0);
    const second = Number(match[6] || 0);
    if (
        month < 1 || month > 12 ||
        day < 1 || day > 31 ||
        hour > 23 || minute > 59 || second > 59
    ) {
        return null;
    }

    const date = new Date(year, month - 1, day, hour, minute, second);
    if (
        date.getFullYear() !== year ||
        date.getMonth() !== month - 1 ||
        date.getDate() !== day
    ) {
        return null;
    }
    return Number.isNaN(date.getTime()) ? null : date;
}

export function getMessageDate(message) {
    if (!message || typeof message !== "object") {
        return null;
    }

    return (
        parseChatDateNumber(message.timestamp) ||
        parseChatDateNumber(message.create_datetime) ||
        parseChatDateNumber(message.update_datetime) ||
        parseChatDateTimeLocal(message.timeISODatetime) ||
        parseChatDateKey(message.timeISODate)
    );
}

export function getMessageDateKey(message) {
    if (!message || typeof message !== "object") {
        return "";
    }

    // timeISODate dari API sudah dihitung dengan timezone lisensi. Gunakan
    // lebih dulu agar separator konsisten dengan jam pesan yang ditampilkan.
    const isoDate = parseChatDateKey(message.timeISODate);
    if (isoDate) {
        return formatChatDateKey(isoDate);
    }

    const isoDateTime = parseChatDateTimeLocal(message.timeISODatetime);
    if (isoDateTime) {
        return formatChatDateKey(isoDateTime);
    }

    return formatChatDateKey(getMessageDate(message));
}

export function formatChatDateSeparator(dateKey, now = new Date(), timeZone = "") {
    const date = parseChatDateKey(dateKey);
    if (!date) {
        return "Tanggal tidak diketahui";
    }

    const current = now instanceof Date && !Number.isNaN(now.getTime())
        ? now
        : new Date();
    const currentKey = formatChatDateKeyInTimeZone(current, timeZone);
    const currentDate = parseChatDateKey(currentKey) || current;
    const yesterday = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 1);
    const yesterdayKey = formatChatDateKey(yesterday);
    const normalizedKey = formatChatDateKey(date);

    if (normalizedKey === currentKey) {
        return "Hari ini";
    }
    if (normalizedKey === yesterdayKey) {
        return "Kemarin";
    }

    return padChatDatePart(date.getDate()) + " " +
        CHAT_DATE_MONTHS_ID[date.getMonth()] + " " + date.getFullYear();
}

export function groupMessagesByChatDate(messages, now = new Date(), timeZone = "") {
    const groups = [];
    const groupMap = new Map();

    (messages || []).forEach(message => {
        const key = getMessageDateKey(message) || "unknown";
        let group = groupMap.get(key);
        if (!group) {
            group = {
                key: key,
                label: key === "unknown"
                    ? "Tanggal tidak diketahui"
                    : formatChatDateSeparator(key, now, timeZone),
                messages: []
            };
            groupMap.set(key, group);
            groups.push(group);
        }
        group.messages.push(message);
    });

    // Jangan mengurutkan group berdasarkan date key. Chat Room mengikuti
    // urutan pesan dari API/Pusher; separator hanya mengikuti perubahan
    // tanggal pada urutan tersebut.
    return groups;
}

//formatDateForMessage
export function formatDateForMessage(dateValue, formatType = "ISODatetime") {
    var date = new Date(dateValue)

    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();
    var outputDate = ""
    if (Number.isNaN(monthIndex) == true) {
        return "-"
    }

    var hours = date.getHours();
    hours = (hours < 10) ? '0' + hours : hours
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    monthIndex = (monthIndex + 1)
    monthIndex = (monthIndex < 10) ? "0" + monthIndex : monthIndex
    day = (day < 10) ? "0" + day : day
    minutes = (minutes < 10) ? "0" + minutes : minutes
    seconds = (seconds < 10) ? "0" + seconds : seconds
    switch (formatType) {

        case 'MinuteHour':
            outputDate = hours + ":" + minutes;
            break;
        case 'ISODate':
            outputDate = year + '-' + monthIndex + '-' + day;
            break;
        case 'ISODatetime':
            outputDate = year + '-' + monthIndex + '-' + day + ' ' + hours + ":" + minutes + ":" + seconds;
            break;
    }
    return outputDate;
}


export function createChannel(name = 'member-type-channel') {
  let bc = null;
  try {
    bc = new BroadcastChannel(name);
  } catch (e) {
    bc = null;
  }

  return {
    send(msg) {
      if (bc) {
        bc.postMessage(msg);
      } else {
        // fallback via localStorage
        localStorage.setItem(name, JSON.stringify({ ...msg, __ts: Date.now() }));
      }
    },
    on(handler) {
      if (bc) {
        bc.onmessage = (ev) => handler(ev.data);
      } else {
        window.addEventListener('storage', (e) => {
          if (e.key === name && e.newValue) {
            try {
              handler(JSON.parse(e.newValue));
            } catch (err) {}
          }
        });
      }
    },
    close() {
      if (bc) bc.close();
    }
  };
}


// WEBPACK FOOTER //
// ./src/utils/helper.js